(function () {
  if (!/^\/collections\//.test(window.location.pathname)) {
    return;
  }

  var RESULTS_PER_PAGE = 48;
  var SEARCHANISE_OPTIONS = {
    ResultsItemCount: RESULTS_PER_PAGE,
    ResultsEnableInfiniteScrolling: "Y",
    LabelResultsInfiniteScrollingLoadMore: "Load more 48 items"
  };
  var SORT_LABELS = {
    Bestselling: "Best Sellers",
    Relevance: "Relevance",
    "Title: A to Z": "Title: A to Z",
    "Title: Z to A": "Title: Z to A",
    "Date: Old to New": "Date: Old to New",
    "Date: New to Old": "Date: New to Old",
    "Price: Low to High": "Price: Low to High",
    "Price: High to Low": "Price: High to Low",
    "Discount: High to Low": "Discount: High to Low"
  };
  var pendingLoadMoreStartIndex = null;
  var sortLabelUpdateRequested = false;

  function normalizeLegacyShopifyFilterParams() {
    if (typeof URLSearchParams === "undefined") {
      return;
    }

    var params = new URLSearchParams(window.location.search);
    var changed = false;
    var vendorValues = params.getAll("filter.p.vendor").filter(Boolean);

    if (vendorValues.length && !params.has("rb_vendor")) {
      params.set("rb_vendor", vendorValues.join("|"));
      params.delete("page");
      changed = true;
    }

    if (vendorValues.length) {
      params.delete("filter.p.vendor");
      changed = true;
    }

    if (!changed) {
      return;
    }

    var query = params.toString();
    var nextUrl = window.location.pathname + (query ? "?" + query : "") + window.location.hash;

    window.history.replaceState({}, "", nextUrl);
  }

  normalizeLegacyShopifyFilterParams();

  window.Searchanise = window.Searchanise || {};
  window.Searchanise.options = Object.assign({}, window.Searchanise.options, SEARCHANISE_OPTIONS);
  window.Searchanise.userOptions = Object.assign({}, window.Searchanise.userOptions, SEARCHANISE_OPTIONS);
  window.Searchanise.ResultsParams = Object.assign({}, window.Searchanise.ResultsParams, {
    maxResults: RESULTS_PER_PAGE
  });

  function setSearchanisePageSize() {
    if (!window.Searchanise) {
      return;
    }

    window.Searchanise.options = Object.assign({}, window.Searchanise.options, SEARCHANISE_OPTIONS);
    window.Searchanise.userOptions = Object.assign({}, window.Searchanise.userOptions, SEARCHANISE_OPTIONS);
    window.Searchanise.ResultsParams = Object.assign({}, window.Searchanise.ResultsParams, {
      maxResults: RESULTS_PER_PAGE
    });

    if (typeof window.Searchanise.SetResultsParams === "function") {
      window.Searchanise.SetResultsParams({ maxResults: RESULTS_PER_PAGE });
    }
  }

  function normalizeSortLabel(label) {
    var cleanLabel = (label || "").replace(/^Sort by:\s*/i, "").trim();
    return SORT_LABELS[cleanLabel] || cleanLabel;
  }

  function updateSortLabel() {
    var button = document.querySelector("#snize_results .snize-main-panel-dropdown-button");

    if (!button) {
      return;
    }

    var label = normalizeSortLabel(button.textContent);
    button.setAttribute("data-sort-label", label ? "Sort by: " + label : "Sort by");
  }

  function getProducts() {
    return Array.prototype.slice.call(document.querySelectorAll("#snize_results .snize-product"));
  }

  function scrollToLoadedProducts() {
    if (pendingLoadMoreStartIndex === null) {
      return;
    }

    var products = getProducts();

    if (products.length <= pendingLoadMoreStartIndex) {
      return;
    }

    var target = products[pendingLoadMoreStartIndex];
    pendingLoadMoreStartIndex = null;

    function scrollToTarget() {
      var headerOffset = 120;
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: Math.max(0, top),
        behavior: "smooth"
      });
    }

    window.requestAnimationFrame(function () {
      window.setTimeout(scrollToTarget, 80);
      window.setTimeout(scrollToTarget, 350);
    });
  }

  function syncSearchaniseCollection() {
    setSearchanisePageSize();
    updateSortLabel();
  }

  function scheduleSortLabelUpdate() {
    if (sortLabelUpdateRequested) {
      return;
    }

    sortLabelUpdateRequested = true;

    window.requestAnimationFrame(function () {
      sortLabelUpdateRequested = false;
      updateSortLabel();
    });
  }

  function handleCollectionMutation() {
    scheduleSortLabelUpdate();
    scrollToLoadedProducts();
  }

  document.addEventListener("click", function (event) {
    if (!(event.target instanceof Element)) {
      return;
    }

    var loadMoreButton = event.target.closest("#snize_results .snize-pagination-load-more");

    if (!loadMoreButton) {
      return;
    }

    pendingLoadMoreStartIndex = getProducts().length;
  }, true);

  document.addEventListener("Searchanise.Loaded", syncSearchaniseCollection);
  document.addEventListener("DOMContentLoaded", syncSearchaniseCollection);

  new MutationObserver(handleCollectionMutation).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
